// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__BLd2E","modal__exit-button":"modal_modal__exit-button__sTB3x"};